import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHConvenioUpd = async (credentials, data) => {
    const body = {
        service: "RNHConvenioUpd",
        params: {
            rnhConvenioId: data?.id,
            rnhConvenioCod: data?.cod,
            rnhConvenioLey: data?.ley,
            // El back espera string. Se convierte aca, en el borde de la API, para que
            // cualquier llamador quede cubierto; el null se conserva cuando no hay valor.
            rnhConvenioCargaSemanal:
              data?.cargaSemanal != null ? String(data.cargaSemanal) : null,
            rnhConvenioVersion: data?.version,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
